export enum DoughnutChartColors {
  SUCCESS = "#69d488",
  ERROR = "#c90000",
  BLUE = "#16a4f6",
  PINK = "#cd8de5",
  GRAY = "#e2e2eb",
  ORANGE = "#f0a13b",
}
